import React, { useEffect } from "react";
import { useState } from "react";

import { useNavigate } from "react-router-dom";

import "../Styles/Add.css";
import axios from "axios";
import Cookies from "js-cookie";

export default function Add() {
    const [ingredients, setIngredients] = useState([""]);
    const [steps, setSteps] = useState([""]);
    const [tags, setTags] = useState([""]);
    const [categories, setCategories] = useState([]);
    const [images, setImages] = useState([]);
    const navigate = useNavigate();

    const addIngredient = (e) => {
        e.preventDefault();
        if (document.activeElement !== e.target) return;
        setIngredients([...ingredients, ""]);
    }

    function changeIngredient(e) {
        e = e.target;
        const index = e.dataset.index;
        if (ingredients[index] === e.value) return;
        ingredients[index] = e.value;
        setIngredients(ingredients);
    }
    
    const addStep = (e) => {
        e.preventDefault();
        setSteps([...steps, ""]);
    }

    function changeStep(e) {
        e = e.target;
        const index = e.dataset.index;
        if (steps[index] === e.value) return;
        steps[index] = e.value;
        setSteps(steps);
    }

    function addTag(e) {
        e.preventDefault();
        setTags([...tags, ""]);
    }

    function changeTag(e) {
        e = e.target;
        const index = e.dataset.index;
        if (tags[index] === e.value) return;
        tags[index] = e.value;
        setTags(tags);
    }

    function sendRecipe(e) {
        e.preventDefault();
        e.target.disabled = true;
        const form = e.target.form;
        const data = new FormData(form);
        let formData = new FormData();
        formData.append("title", data.get("title"));
        let filteredIngredients = ingredients.filter((ingredient) => ingredient !== "");
        formData.append("ingredients", filteredIngredients.join(""));
        let filteredSteps = steps.filter((step) => step !== "");
        formData.append("steps", filteredSteps.join(""));
        formData.append("time", data.get("time"));
        formData.append("people", data.get("people"));
        formData.append("tags", tags.join(","));
        formData.append("category", data.get("category"));
        var ins = form.images.files.length;
        for (var x = 0; x < ins; x++) {
            formData.append("images[]", form.images.files[x]);
        }
        formData.append("token", Cookies.get("token"));
        axios.post("https://anatole-sot.xyz/api/recettes-gibli/new-recipe.php", formData, {headers: {"Content-Type": "multipart/form-data"}})
        .then((response) => {
            if (response.data.status === "success") {
                alert("Votre recette a bien été ajoutée");
                navigate("/recipes/"+response.data.data.recipe_id);
            } else {
                alert(response.data.data);
            }
        }
        )
        .catch((error) => {
            console.log(error);
        }
        )
    }

    function previewImages(e) {
        e.preventDefault();
        const form = e.target.form;
        var ins = form.images.files.length;
        let images = [];
        for (var x = 0; x < ins; x++) {
            let reader = new FileReader();
            reader.onload = function (e) {
                images.push(e.target.result);
                setImages(images);
            }
            reader.readAsDataURL(form.images.files[x]);
        }
    }


    useEffect(() => {
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-categories.php")
        .then((response) => {
            if (response.data.status === "error") {
                alert(response.data.data);
                return;
            }
            setCategories(response.data.data);
        })
        .catch((error) => {
            console.log(error);
        })
    }, []);


    return (
        <div className="Add">
            <h1>Ajouter une recette</h1>
            <form>
                <label htmlFor="title">Nom de la recette</label>
                <input type="text" id="title" name="title" placeholder="Gateau au chocolat" required/>
                
                <div className="infos">
                    
                    <div>
                        <div>
                            <input type="number" id="time" name="time" required/>
                            <span className="emoji">⏱️</span>
                        </div>
                    </div>
                    
                    <div>
                        <label htmlFor="category">Catégorie</label>
                        <select id="category" defaultValue="" name="category" required>
                            <option value="" disabled hidden>Choisissez une catégorie</option>
                            {categories.map((category, index) => {
                                return (
                                    <option key={index} value={category.ID}>{category.Name}</option>
                                );
                            })
                            }
                        </select>
                    </div>
                    <div>
                        <div>
                            <input type="number" id="people" name="people" required/>
                            <span className="emoji">👤</span>
                        </div>
                    </div>
                    
                </div>


                <label htmlFor="ingredients">Ingrédients</label>
                <ul>
                {ingredients.map((ingredient, index) => {
                    return (
                        <li key={index}>
                            <input type="text" name="ingredient" defaultValue={ingredient} onChange={changeIngredient} data-index={index} required/>
                        </li>
                    );
                })
                }
                </ul>
                <button onClick={addIngredient}>Ajouter un ingrédient</button>
                
                <label htmlFor="steps">Étapes</label>
                <ol>
                {steps.map((step, index) => {
                    return (
                        <li key={index}>
                            <textarea type="text" name="step" defaultValue={step} onChange={changeStep} data-index={index} required/>
                        </li>
                    );
                })
                }
                </ol>
                <button onClick={addStep}>Ajouter une étape</button>
                
                <label htmlFor="tags">Tags</label>
                <ul>
                {tags.map((tag, index) => {
                    return (
                        <li key={index}>
                            <input type="text" name="tag" defaultValue={tag} onChange={changeTag} data-index={index} required/>
                        </li>
                    );
                })
                }
                </ul>
                <button onClick={addTag}>Ajouter un tag</button>

                <section>
                <label htmlFor="images">Images</label>
                <input type="file" id="images" name="images" onChange={previewImages} multiple required/>
                <div className="preview">
                    {images.map((image, index) => {
                        
                        return (
                            image.startsWith("data:video") ? 
                            <video key={index} src={image} alt="preview" controls></video>
                             : <img key={index} src={image} alt="preview"/>
                        );
                    })}
                </div>
                </section>

                <button type="submit" onClick={sendRecipe}>Envoyer la recette</button>
            </form>
        </div>
    );
}